<template>
  <div class="wrapper">
    <div>
      <CRow class="mt-3">
        <CCol sm="12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-3">
                <div class="col-md-3">
                  <label class="mr-2">Status</label>
                  <select class="form-control" v-model="status" @change="loadData">
                    <option value="">All</option>
                    <option value="sent">Sent</option>
                    <option value="failed">Failed</option>
                    <option value="queued">Queued</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="mr-2">Notification Type</label>
                  <select class="form-control" v-model="notification_type" @change="loadData">
                    <option value="">All</option>
                    <option v-for="type in notificationTypes" :key="type.value" :value="type.value">{{type.label}}</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="mr-2">Date From</label>
                  <input type="date" class="form-control" v-model="date_from" @change="loadData">
                </div>
                <div class="col-md-3">
                  <label class="mr-2">Date To</label>
                  <input type="date" class="form-control" v-model="date_to" @change="loadData">
                </div>
              </div>

              <Datatable
                :items="items"
                :fields="fields"
                :meta="meta"
                @per_page="handlePerPage"
                @pagination="handlePagination"
                @search="handleSearch"
                @sort="handleSort"
                :btn_show="true"
                :btn_edit="false"
                :btn_edit_birthday="false"
                :btn_deactivate="false"
                :btn_reactivate="false"
                :btn_destroy="false"
                :is_uuid="false"
                :is_search_by_date="false"
                @show="handleShow"
              />
            </div>
          </div>
        </CCol>
      </CRow>

      <CModal title="Delivery Detail" :show.sync="detailModal" color="info">
        <div v-if="selected">
          <p><b>Title:</b> {{ selected.title }}</p>
          <p><b>Body:</b> {{ selected.body_snippet }}</p>
          <p><b>Status:</b> {{ selected.status }}</p>
          <p v-if="selected.fail_reason"><b>Fail Reason:</b> {{ selected.fail_reason }}</p>
          <p><b>Triggered By:</b> {{ selected.triggered_by || '-' }}</p>
          <p><b>Raw Provider Response:</b></p>
          <pre>{{ selected.fcm_response }}</pre>
        </div>
        <template #footer>
          <CButton color="secondary" @click="detailModal = false">Close</CButton>
        </template>
      </CModal>
    </div>
  </div>
</template>

<script>
import Datatable from '@/components/datatables.vue'
import notificationLogs from '@/services/notificationLogs'
import EventBus from '@/eventBus';

export default {
  name: 'NotificationLogs',
  components: { Datatable },
  data(){
    return{
      fields: [
          {key: 'recipient', label: 'Recipient', sortable: false},
          {key: 'title', sortable: false},
          {key: 'notification_type', label: 'Type', sortable: false},
          {key: 'status', sortable: false},
          {key: 'fail_reason', label: 'Fail Reason', sortable: false},
          {key: 'triggered_by', label: 'Triggered By', sortable: false},
          {key: 'created_at', label: 'Sent At', sortable: true},
          {key: 'action', label: 'Action', sortable: false},
      ],
      items: [],
      meta: [],
      current_page: 1,
      per_page: 25,
      search: '',
      sortBy: 'created_at',
      sortByDesc: true,
      status: '',
      notification_type: '',
      date_from: '',
      date_to: '',
      detailModal: false,
      selected: null,
      notificationTypes: [
        { value: 1, label: 'System' },
        { value: 2, label: 'Announcement' },
        { value: 10, label: 'iCare Join Request' },
        { value: 11, label: 'iCare Join Accepted' },
        { value: 12, label: 'iCare Follow-up Reminder' },
        { value: 13, label: 'iCare Join Rejected' },
        { value: 14, label: 'iCare Member Planted' },
        { value: 15, label: 'iCare Member Off-Planted' },
        { value: 16, label: 'iCare Member Absent 1 Month' },
        { value: 17, label: 'iCare Member Absent 2 Months' },
        { value: 18, label: 'iCare Absence Leader Notice' },
      ],
    }
  },

  mounted (){
     this.loadData()
   },

  methods: {
    loadData() {
      var params = {
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        status: this.status,
        notification_type: this.notification_type,
        date_from: this.date_from,
        date_to: this.date_to,
      }

      notificationLogs.getNotificationLogsDataSource(params)
      .then(res => {
          let getData = res.data
          this.items = getData.data
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data: err.response && err.response.data ? err.response.data.message : err.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },

    handlePerPage(val) {
        this.per_page = val
        this.loadData()
    },

    handlePagination(val) {
        this.current_page = val
        this.loadData()
    },

    handleSearch(val) {
        this.search = val
        this.current_page = 1
        this.loadData()
    },

    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },

    handleShow(id) {
        this.selected = this.items.find(i => i.id === id)
        this.detailModal = true
    },
  }
}
</script>
